<nav
  *ngIf="
    !router.url.startsWith('/authenticate') &&
    !router.url.startsWith('/clientselect') &&
    !router.url.startsWith('/qbocallback') &&
    !router.url.startsWith('/qboredirectfinished')
  "
  class="navbar navbar-expand-lg fixed-top d-print-none"
  (focusout)="navFocusOut($event)">
  <div id="instance-watermark">
    <p *ngIf="instanceWatermark">
      <span *ngFor="let i of wmIter"> &nbsp;{{ instanceWatermark }}&nbsp; </span>
    </p>
  </div>
  <div class="navbar-brand" href="#"><img src="assets/images/cp_green_circle.png" /></div>
  <div class="navbar-nav">
    <span *ngIf="!isLandingPortal && selClient | async; let client" class="client-info">
      <strong>{{ client.DBA || client.Name }}</strong>
      <div *ngIf="!isEmployeePortal">
        <small
          >Id: {{ client.Id }}&nbsp;
          <span class="client-status" *ngIf="!isClientPortal && client.Status"
            >|&nbsp;{{ client.Status }} as of
            {{ client.StatusEffectiveDate | date: 'MM/dd/yyyy' }}</span
          >
        </small>
      </div>
    </span>
    <button
      *ngIf="loggedIn"
      class="navbar-toggler justify-content-end me-3"
      type="button"
      (click)="isMenuCollapsed = !isMenuCollapsed">
      &#9776;
    </button>
  </div>
  <div
    *ngIf="loggedIn && validRoles"
    [ngbCollapse]="isMenuCollapsed"
    class="navbar-collapse justify-content-start justify-content-lg-end">
    <div class="navbar-nav">
      <div class="d-lg-none" *ngIf="(clientCode | async) != '' && (clientCode | async) != null">
        <lib-client-nav-list [sideView]="false"></lib-client-nav-list>
      </div>
      <ng-container *hasMinRole="'CSR1'">
        <!-- For Supervisors and CSRs, display 'CSR Home'. for Banking users, display 'Home'-->
        <button
          *ngIf="
            router.url !== '/home' && router.url !== '/' && !isClientPortal && !isEmployeePortal
          "
          class="btn btn-link nav-link flex-end--mobile"
          cpGTagEvent
          [params]="{ event_label: 'navigation_home' }"
          (click)="csrHomeClicked()">
          <strong>
            <img class="me-3 ms-3 ms-lg-0 d-inline-block d-lg-none" src="assets/icons/home.svg" />
            <span>CSR&nbsp;</span>Home
          </strong>
        </button>
      </ng-container>
      <!-- show the release notes icon if enabled via the app config -->
      <button
        class="btn btn-link nav-link release-notes-button d-flex align-items-center"
        *ngIf="enableReleaseNotes && releaseNotes && releaseNotes.length && validRoles"
        (click)="isMenuCollapsed = true; showReleaseNotes()"
        cpGTagEvent
        [params]="{ event_label: 'header_release_notes' }">
        <span>{{ unreadArticleIds.length > 0 ? unreadArticleIds.length : ' ' }}&nbsp; </span>
        <img class="me-3 ms-3 ms-lg-0 me-lg-0" src="assets/icons/megaphone.svg" />
        <span class="d-inline-block d-lg-none">Release Notes</span>
      </button>
      <ng-container *hasMinRole="'CSR1'">
        <!-- notifications drop down -->
        <button
          class="btn btn-link nav-link"
          id="navNotifyDropDown"
          *ngIf="validRoles"
          (click)="checkNotifyMode(); notifyDropDown.toggle()"
          cpGTagEvent
          [params]="{ event_label: 'header_notifications' }">
          <span *ngIf="notificationCount"
            >{{ notificationCount > 0 ? notificationCount : ' ' }}&nbsp;</span
          >
          <img class="me-3 ms-3 ms-lg-0 me-lg-0" src="assets/icons/notification.svg" />
          <span class="d-inline-block d-lg-none">Notifications</span>
        </button>
        <div
          #notifyDropDown="ngbDropdown"
          ngbDropdown
          display="dynamic"
          class="d-inline-block"
          placement="bottom-right">
          <span id="navNotifyDropDownAnchor" ngbDropdownAnchor></span>
          <div id="navNotifyDropDownItems" ngbDropdownMenu aria-labelledby="navNotifyDropDown">
            <h4><span *ngIf="viewDelNotifications">Dismissed </span>Notifications</h4>
            <button
              id="navNotifyClose"
              class="btn btn-link"
              (click)="notifyDropDown.close()"
              cpGTagEvent
              trackOn="click"
              action="clicked"
              [params]="{ event_label: 'header_notifications_dropdown_close' }">
              <img class="close-icon" src="assets/icons/close.svg" />
            </button>
            <div class="dropdown-divider"></div>
            <div *ngIf="notifications && notifications.length > 0 && !notificationViewMode">
              <div style="max-height: 500px; overflow-y: auto; position: relative">
                <div *ngFor="let notification of notifications">
                  <div class="notification-dropdown-item" (click)="viewNotification(notification)">
                    <svg height="10" width="10" class="unread-indicator">
                      <circle
                        cx="5"
                        cy="5"
                        r="5"
                        stroke="none"
                        stroke-width="0"
                        attr.fill="{{ notification.IsRead ? '#D9D9D9' : '#009AA7' }}" />
                    </svg>
                    <div class="title-line">
                      {{ notification.Subject.slice(0, 30)
                      }}{{ notification.Subject.length > 30 ? '...' : '' }}
                    </div>
                    <div class="subject-line">
                      {{ notification.Body.slice(0, 35)
                      }}{{ notification.Body.length > 35 ? '...' : '' }}
                    </div>
                    <div class="sent-line">
                      {{ notification.TimeCreated | date: 'h:mma MMMM d' }}
                    </div>
                    <div class="right-arrow"><i class="fas fa-chevron-right"></i></div>
                  </div>
                  <div class="dropdown-divider"></div>
                </div>
              </div>
              <div style="padding-top: 10px">
                <lib-pagination
                  [pagination]="notifyPagination"
                  (pageChanged)="loadNotifications($event)"></lib-pagination>
              </div>
              <div class="dropdown-divider"></div>
              <a
                *ngIf="viewDelNotifications"
                class="btn btn-link"
                (click)="viewActiveNotifications()"
                style="padding-left: 0">
                View active
              </a>
              <a
                *ngIf="!viewDelNotifications"
                class="btn btn-link"
                (click)="viewDismissedNotifications()"
                style="padding-left: 0">
                View dismissed
              </a>
              <a
                *ngIf="!viewDelNotifications"
                class="btn btn-link"
                id="navNotifyClear"
                (click)="clearAllAlerts(); notifyDropDown.close()"
                >Remove all alerts</a
              >
            </div>
            <div
              *ngIf="(!notifications || notifications.length == 0) && !notificationViewMode"
              style="white-space: nowrap; padding: 10px 0">
              <em>No notifications right now...</em>
              <div class="dropdown-divider"></div>
              <a
                *ngIf="!viewDelNotifications"
                class="btn btn-link"
                (click)="viewDismissedNotifications()"
                style="padding-left: 0">
                View dismissed
              </a>
              <a
                *ngIf="viewDelNotifications"
                class="btn btn-link"
                (click)="viewActiveNotifications()"
                style="padding-left: 0">
                View active
              </a>
            </div>
            <div *ngIf="notificationViewMode && activeNotification != null">
              <p>
                <a (click)="viewNotificationList()"
                  ><small><i class="fas fa-chevron-left">&nbsp;</i></small
                  ><span style="font-weight: 600">Back</span></a
                >
              </p>
              <p class="title">{{ activeNotification.Subject }}</p>
              <p style="color: #616161; max-height: 350px; overflow-y: auto">
                {{ activeNotification.Body }}
              </p>
              <small style="color: #7f7f7f">{{
                activeNotification.TimeCreated | date: 'h:mma MMMM d'
              }}</small>
              <div class="dropdown-divider"></div>
              <a
                *ngIf="!viewDelNotifications"
                class="btn btn-link"
                (click)="clearAlert()"
                style="padding-left: 0"
                >Remove</a
              >
            </div>
          </div>
        </div>
      </ng-container>
      <!-- account drop down -->
      <button
        class="btn btn-link nav-link dropdown-toggle"
        id="navProfileDropDown"
        cpGTagEvent
        (click)="$event.stopPropagation(); profileDropdown.toggle()"
        [params]="{ event_label: 'header_user_menu' }">
        <img class="me-3 ms-3 ms-lg-0 me-lg-0" src="assets/icons/profile.svg" />&nbsp;
        <span class="user-name">{{ userName }}&nbsp;</span>
      </button>
      <div
        ngbDropdown
        #profileDropdown="ngbDropdown"
        display="dynamic"
        class="d-inline-block"
        placement="bottom-right">
        <span id="navProfileDropDownAnchor" ngbDropdownAnchor></span>
        <div id="navProfileDropDownItems" ngbDropdownMenu aria-labelledby="navProfileDropDown">
          <button
            ngbDropdownItem
            (click)="isMenuCollapsed = true; navigateToAccountManagement()"
            cpGTagEvent
            [params]="{ event_label: 'header_logout' }">
            <img src="assets/icons/gear.svg" /><span class="ms-3"> Manage Account</span>
          </button>
          <button
            *ngFor="let info of switchPortalInfo"
            ngbDropdownItem
            (click)="navigateToPortal(info)">
            <img src="{{ info.Icon }}" /><span class="ms-3"> {{ info.DisplayName }}</span>
          </button>
          <button
            ngbDropdownItem
            (click)="isMenuCollapsed = true; logout()"
            cpGTagEvent
            [params]="{ event_label: 'header_logout' }">
            <img src="assets/icons/Sign-out.svg" /><span class="ms-3"> Sign out</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>
<ng-template #releaseNotesTemplate>
  <release-notes [articles]="releaseNotes"></release-notes>
</ng-template>
